







































































import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator";
// import { decorationData, questionData, testData, QuestionDataType } from "../../config/questionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import { deleteActivityUserDraft } from "@/modules/activityManage/api/doctorActivity";

@Component({
  name: "resultListDialog",
  components: {},
  filters: {},
})
export default class QuestionnaireEdit extends Vue {
  @PropSync("modalVisible", { type: Boolean }) visible!: Boolean;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  ruleList?: any;
  @Prop({
    type: Number,
    default: 100,
  })
  maxScore?: any;
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  resultList?: any;

  ifItems: any = [];
  private localSubmit = {};
  private postForm: any = {
    itemShowLogics: [],
  };

  // private rules = {
  //   title: [{ required: true, type: "string", message: "请填写标题", trigger: "blur" }],
  // };

  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get dataList() {
    return QuestionnaireEditModule.dataList;
  }
  // get formLogicConfig() {
  //   return QuestionnaireEditModule.formLogicConfig;
  // }

  checkListOverLap(tindex: Number, day: Number) {
    let findOverLap = this.postForm.itemShowLogics.some((task: any, index: number) => {
      if (index != tindex) {
        let startScore = 0;
        let endScore = 0;

        startScore = task.ifScoreStart;
        endScore = task.ifScoreEnd;

        return (startScore || startScore === 0 ? startScore <= day : false) && (endScore ? day <= endScore : false);
      } else {
        return false;
      }
    });
    return findOverLap;
  }
  ifScoreStartValidator(rule: any, value: any, callback: any) {
    let index = rule.field.split(".")[1];
    if (value > this.maxScore) {
      return callback(new Error("超过最大可设置分数"));
    }
    if (index > 0) {
      if (this.checkListOverLap(index, value)) {
        return callback(new Error("分数不能重合，请重新设置"));
      }
    }

    callback();
  }

  ifScoreEndValidator(rule: any, value: any, callback: any) {
    if (value > this.maxScore) {
      return callback(new Error("超过最大可设置分数"));
    }
    let index = rule.field.split(".")[1];
    if (this.postForm.itemShowLogics[index].ifScoreStart && this.postForm.itemShowLogics[index].ifScoreStart > value) {
      return callback(new Error("结束分数需大于开始分数"));
    }
    if (this.checkListOverLap(index, value)) {
      return callback(new Error("分数不能重合，请重新设置"));
    }
    callback();
  }
  onOpen() {
    this.initPostForm();
    this.initIfItems();
  }
  deleteLogic(index: number) {
    this.postForm.itemShowLogics.splice(index, 1);
  }
  addLogic() {
    //
    this.postForm.itemShowLogics.push({
      ifScoreStart: "",
      ifScoreEnd: "",
      nextResult: [],
    });
  }

  validatenextResult(rule: any, value: Array<string>, callback: any) {
    // let sameLogic = this.postForm.itemShowLogics.filter((item: any) => {
    //   return item.nextResult == value;
    // });

    // if (sameLogic.length > 1) {
    //   callback(new Error("与已有逻辑冲突，请重新设置"));
    // } else {
    // console.log("validatenextResult", rule.field);
    if (rule.field) {
      let findEmpty = value.some((id: any) => {
        return !this.resultList.some((nitem: any) => {
          return nitem.id == id;
        });
      });
      if (findEmpty) {
        return callback(Error("操作项目已失效 请重选"));
      }

      return callback();
    }
    // }
  }
  initIfItems() {
    let dataList = JSON.parse(JSON.stringify(this.dataList));

    this.ifItems = dataList.filter((item: any) => {
      return [1, 2, 9, 10].includes(item.componentName);
    });
  }
  getFormInstance() {
    return this.$refs.postForm as any;
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }

  initPostForm() {
    let postForm = {
      itemShowLogics: JSON.parse(JSON.stringify(this.ruleList)),
    };

    this.postForm = postForm;
  }

  // $ handleModules

  getModulesConfigInstance() {
    return this.$refs.modulesConfig as any;
  }

  getSubmitConfigInstance() {
    return this.$refs.submitConfig as any;
  }
  async validateForSave() {
    // 保存总配置时,用来最终效验有没有失效项目
    this.clearValidate();

    this.initIfItems();
    this.initPostForm();
    return await this.validate();
  }
  async validate() {
    if (this.postForm.itemShowLogics.length == 0) {
      return true;
    }

    if (!this.getFormInstance()) {
      // this.$message.warning("请检查规则设置");
      this.visible = true;
      return false;
    }
    let result = await this.getFormInstance()
      .validate()
      .catch(() => {
        return false;
      });
    console.log("itemShowLogicsValidate", result);
    if (result) {
      // QuestionnaireEditModule.SET_FORM_LOGIC_CONFIG(this.postForm);
    }
    return result;
  }
  closeDialog() {
    // this.initPostForm();
    this.visible = false;
  }
  async handleCommit() {
    let vali = await this.validate();
    console.log("validate", vali);
    if (vali) {
      this.visible = false;
      this.$emit("success", JSON.parse(JSON.stringify(this.postForm.itemShowLogics)));
    }
  }
}
